<template>
<div>
    <el-row class="cs-contentContainer">
        <el-col :span="4" class="cs-main-left-container">
            <navigator></navigator>
        </el-col>
        <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
            <div class="cs-fullHeight cs-contentContainer-right">
                <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                    <el-row>
                        <el-col>
                            <span class="cs-title">学期管理</span>
                            <el-tabs v-model="activeCourseType" type="card">
                                <el-tab-pane :key="item.Value" v-for="item in courseTypes" :label="item.Text" :name="item.NameValue">
                                    <span slot="label">{{item.Text}}</span>
                                    <div v-if="item.NameValue === '1'">
                                        <universityTerms></universityTerms>
                                    </div>

                                    <div v-if="item.NameValue === '3'">
                                       <trainingTerms></trainingTerms>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-col> 
    </el-row>
</div>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
    .grid-content {
        margin-top: 15px;

        .cs-schedule-buttonContainer {
            text-align: right;
        }
    }

    .gray {
        color: gray;
    }
}
</style>

<script>
import navigator from "../../components/navigator"; 
import universityTerms from "../../components/termManagement/universityTerms";
import trainingTerms from "../../components/termManagement/trainingTerms"
import {
    getAllTerms
} from "../../service/termManage.service.js";
import {
    getCurrentTerm
} from "../../service/common.service.js";
import {
    getCourseType
} from "../../config/mUtils.js";

export default {
    data() {
        return { 
            courseTypes: [], 
            activeCourseType:"1"
        }
    },
    components: {
        navigator, 
        universityTerms,
        trainingTerms
    },
    created() {
        this.courseTypes = getCourseType(true, this.USERMANAGER.isVocationalTrainingManager);  
        if (this.USERMANAGER.isVocationalTrainingManager){
            this.activeCourseType = "3";
        }
    },
    methods: {   
    },
    watch: { 
    }
}
</script>



// WEBPACK FOOTER //
// src/page/admin/termManagement.vue